import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PreferencesService } from './preferences.service';
import { Observable } from 'rxjs';

@Injectable()
export class PreferencesResolver implements Resolve<any> {
  constructor(private preferencesService: PreferencesService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.preferencesService.getPreferences();
  }
}
